import { createAction } from 'redux-actions';
import { createCallbackActionCreator } from '../../Stream/helpers';
import { actionTypePrefix } from './constants';
export const blockUser = createAction(`${actionTypePrefix}.BLOCK_USER`, (user)=>({
        user
    }));
export const blockUserAndRedirect = createAction(`${actionTypePrefix}.BLOCK_USER_AND_REDIRECT`, (user, redirectLocation)=>({
        user,
        redirectLocation
    }));
export const blockUserSuccess = createAction(`${actionTypePrefix}.BLOCK_USER_SUCCESS`, (userId)=>userId);
export const blockUserFail = createAction(`${actionTypePrefix}.BLOCK_USER_FAIL`, (user, result)=>({
        user,
        result
    }));
export const unblockUser = createAction(`${actionTypePrefix}.UNBLOCK_USER`, (userId)=>userId);
export const unblockUserSuccess = createAction(`${actionTypePrefix}.UNBLOCK_USER_SUCCESS`, (userId)=>userId);
export const unblockUserFail = createAction(`${actionTypePrefix}.UNBLOCK_USER_FAIL`, (userId)=>userId, (userId, result)=>result);
export const searchFriendsWithOptions = createAction(`${actionTypePrefix}.SEARCH_FRIENDS`, (query, callback, options)=>{
    var _options_includeNonFriendExactMatch, _options_userType;
    return {
        query,
        callback,
        isChatContext: options.isChatContext,
        includeNonFriendExactMatch: (_options_includeNonFriendExactMatch = options.includeNonFriendExactMatch) !== null && _options_includeNonFriendExactMatch !== void 0 ? _options_includeNonFriendExactMatch : true,
        userType: (_options_userType = options.userType) !== null && _options_userType !== void 0 ? _options_userType : 'both'
    };
});
export const searchFriends = (query, callback)=>searchFriendsWithOptions(query, callback, {
        includeNonFriendExactMatch: false,
        userType: 'deviant'
    });
export const initializeFriendList = createAction(`${actionTypePrefix}.FRIENDS_INIT`, ()=>({}));
export const fetchMoreFriends = createCallbackActionCreator(`${actionTypePrefix}.FETCH_FRIENDS`);
